/**
 * Token names for code that needs them (charts, canvas). Values live only in tokens.css.
 * Status chip tones (decision O7): in-flight states take the screenshot accent colours,
 * approved/due/rejected take functional colours; chips always carry icon + label.
 */
export const THEMES = ["system", "light", "dark"] as const;
export type ThemePreference = (typeof THEMES)[number];

export type StatusTone =
  | "production" // In production — violet
  | "review" // In review — magenta
  | "editing" // Editing — cyan
  | "planning" // Planning / strategy — info blue
  | "success" // Approved / delivered
  | "warning" // Due / attention / need clarification
  | "danger" // Rejected
  | "neutral"; // New, cancelled, unknown

export const STATUS_TONE_VARS: Record<StatusTone, { fg: string; bg: string }> = {
  production: { fg: "var(--accent-primary-text)", bg: "var(--accent-primary-soft)" },
  review: { fg: "var(--accent-secondary-text)", bg: "var(--accent-secondary-soft)" },
  editing: { fg: "var(--accent-tertiary-text)", bg: "var(--accent-tertiary-soft)" },
  planning: { fg: "var(--status-info)", bg: "var(--status-info-soft)" },
  success: { fg: "var(--status-success)", bg: "var(--status-success-soft)" },
  warning: { fg: "var(--status-warning)", bg: "var(--status-warning-soft)" },
  danger: { fg: "var(--status-danger)", bg: "var(--status-danger-soft)" },
  neutral: { fg: "var(--status-neutral)", bg: "var(--bg-soft)" },
};
